/**
 * Add participant: who the interpreter rings into the call with
 * conference_add. Shared by the web Tools panel and the Terp sheet.
 */
import { typedInviteTarget } from '../vrs-layout/groupInvite';
/**
 * The typed entry as a conference_add target: a VRS number (E.164, read in
 * `dialCountry` when it has no + or 00; callers pass inviteDialCountry()), an
 * @handle or an email. Null when it is none of those.
 *
 * @param {string} text - What the interpreter typed.
 * @param {string} [dialCountry] - The invite dial country (vrs-layout/inviteDialCountry.ts).
 * @returns {InviteTarget | null}
 */
export function addParticipantTarget(text, dialCountry = 'US') {
    const trimmed = text.trim();
    if (!trimmed) {
        return null;
    }
    return typedInviteTarget(trimmed, dialCountry);
}
